import { useReduxSelector } from 'hooks';

export default function useGustoCustomerType(): 'existing-gusto-account' | 'new-gusto-account' | 'unpaid' {
  return useReduxSelector((state) => state.features.GUSTO_PAYROLL_PAID);
}
